import { render, staticRenderFns } from "./TestDataDialog.vue?vue&type=template&id=51755727&scoped=true"
import script from "./TestDataDialog.vue?vue&type=script&lang=ts"
export * from "./TestDataDialog.vue?vue&type=script&lang=ts"
import style0 from "./TestDataDialog.vue?vue&type=style&index=0&id=51755727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51755727",
  null
  
)

export default component.exports